import {message, Tooltip} from "@ui";
import PropTypes from "prop-types";

import {useTranslation} from "react-i18next";
import {PrimaryButton, SecondaryButton} from "@/components/Button";
import useIsMobile from "@/hooks/useIsMobile";
import warningIcon from "../../../../assets/images/modal-icons/advertencia-bell-icon.png";
import copyBtn from "../../../../assets/images/modal-icons/copy-btn.svg";
import {useAppConfig} from "../../../../store/useAppConfig.store";
import {useBalanceStore} from "../../../../store/useBalance.store";
import styles from "../bankOptions.module.css";

const BankPlaza = ({onBack}) => {
  const {t} = useTranslation();
  const bankName = useAppConfig(state => state.bankName);
  const RIF = useAppConfig(state => state.RIF);
  const PagoMovilNumber = useAppConfig(state => state.PagoMovilNumber);
  const handleBankAccountModal = useBalanceStore(state => state.handleBankAccountModal);

  const isMobile = useIsMobile();

  const copyToClipboard = value => {
    navigator.clipboard.writeText(value);
    message.success(t("depositInstructionsCopied"));
  };

  const handleContinueAndReset = () => {
    handleBankAccountModal();
    onBack();
  };

  // Mobile order: RIF, Telefono, Bank
  const mobileItems = [
    {
      label: "RIF",
      value: RIF,
      key: "rif",
    },
    {
      label: t("depositInstructionsMobilePhone"),
      value: PagoMovilNumber,
      key: "phone",
    },
    {
      label: t("depositInstructionsBank"),
      value: bankName,
      key: "bank",
    },
  ];

  const renderMobileItem = item => (
    <div
      key={item.key}
      className={styles.bankRow}
    >
      <p className={styles.bankLabel}>{item.label}</p>
      <Tooltip
        title={t("depositInstructionsCopy")}
        overlayClassName="edit-tooltip"
      >
        <button
          type="button"
          className={styles.mobileCopyButton}
          onClick={() => copyToClipboard(item.value)}
        >
          <img
            src={copyBtn}
            alt="copy"
          />
          <span>{item.value}</span>
        </button>
      </Tooltip>
    </div>
  );

  return (
    <div className={styles.bankOptionsModalContainer}>
      <h4 className={styles.bankOptions_instruction_title}>{t("depositInstructions")}</h4>
      <div style={{fontSize: "var(--primary-font-size)", textAlign: "center"}}>
        <p style={{textAlign: "left"}}>{t("depositInstructionsMessagePlaza")}</p>
        <p
          style={{
            textAlign: "left",
            fontSize: "14px",
            color: "var(--text-secondary)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <img
            src={warningIcon}
            alt="Warning"
            style={{
              width: "20px",
              height: "20px",
              flexShrink: 0,
            }}
          />
          {t("depositInstructionsImportantMessage")}
        </p>
      </div>
      {isMobile && (
        <h4
          style={{
            fontFamily: "var(--font-family)",
            fontWeight: 700,
            textAlignLast: "center",
            fontStyle: "normal",
            lineHeight: "22px",
            letterSpacing: "0%",
            textAlign: "justify",
            color: "var(--text-secondary)",
            marginTop: "1rem",
            marginBottom: "1rem",
          }}
        >
          {t("depositInstructionsCopyBtnTitle")}
        </h4>
      )}
      <div className={styles.bankInfoGroup}>
        {isMobile ? (
          // Mobile layout: RIF, Telefono, Bank with new styling
          mobileItems.map(renderMobileItem)
        ) : (
          // Desktop layout: Bank, RIF, Telefono (original order)
          <>
            {/* Banco */}
            <div className={styles.bankRow}>
              <Tooltip
                title={t("depositInstructionsCopy")}
                overlayClassName="edit-tooltip"
              >
                <img
                  src={copyBtn}
                  alt="copy"
                  className={styles.copyBtnImg}
                  onClick={() => copyToClipboard(bankName)}
                />
              </Tooltip>
              <div className={styles.bankLabelValue}>
                <p className={styles.bankLabel}>{t("depositInstructionsBank")}</p>
                <span className={styles.bankValue}>{bankName}</span>
              </div>
            </div>
            {/* RIF */}
            <div className={styles.bankRow}>
              <Tooltip
                title={t("depositInstructionsCopy")}
                overlayClassName="edit-tooltip"
              >
                <img
                  src={copyBtn}
                  alt="copy"
                  className={styles.copyBtnImg}
                  onClick={() => copyToClipboard(RIF)}
                />
              </Tooltip>
              <div className={styles.bankLabelValue}>
                <p className={styles.bankLabel}>RIF</p>
                <span className={styles.bankValue}>{RIF}</span>
              </div>
            </div>
            {/* Telefono */}
            <div className={styles.bankRow}>
              <Tooltip
                title={t("depositInstructionsCopy")}
                overlayClassName="edit-tooltip"
              >
                <img
                  src={copyBtn}
                  alt="copy"
                  className={styles.copyBtnImg}
                  onClick={() => copyToClipboard(PagoMovilNumber)}
                />
              </Tooltip>
              <div className={styles.bankLabelValue}>
                <p className={styles.bankLabel}>{t("depositInstructionsMobilePhone")}</p>
                <span className={styles.bankValue}>{PagoMovilNumber}</span>
              </div>
            </div>
          </>
        )}
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          gap: "36px",
          marginTop: "60px",
        }}
      >
        <PrimaryButton onClick={handleContinueAndReset}>{t("depositInstructionsContinue")}</PrimaryButton>
        <SecondaryButton onClick={onBack}>{t("depositInstructionsBack")}</SecondaryButton>
      </div>
    </div>
  );
};

BankPlaza.propTypes = {
  onBack: PropTypes.func,
};

export default BankPlaza;
